// extracted by mini-css-extract-plugin
export default {"container":"RoamingBanner_container__VE65i","banner":"RoamingBanner_banner__WPsoD"};